import React from 'react'
import Section from './Section'
import FeatureImageItem from './FeaturesImageItem'
import styles from '../../styles/modules/common/features.module.scss'
import {isMobile, isTablet} from 'react-device-detect';

interface  Props{
    title: string,
    mainSubtitle?: string, // subtitle (below title)
    withSubtitle: boolean, // feature title
    features : {
        featureTitle?: string,
        featureImage: {
            mobile:string,
            desktop:string,
        },
        featureText: string,
        scrollToTop?: boolean,
    }[]
    className?:string,
    isGreyBackground?:boolean,
    sectionClassName?:any,
    isRoundShape?:boolean,
    imageSizeClass?: string,
    elementID?:string,
}


const getImage = (imageDict) => {
    if (typeof imageDict == 'object' ) {
        let image;
        if(isMobile) {
            image =  imageDict && imageDict['mobile'] ? imageDict['mobile'] : imageDict && imageDict['default']
        } else if (isTablet) {
            image =  imageDict && imageDict['tablet']? imageDict['tablet'] : imageDict && imageDict['default']
        } else {
            image =  imageDict && imageDict['desktop']? imageDict['desktop'] : imageDict && imageDict['default']
        }
        return image
    }
    return imageDict; // image is string i.e path
}

const FeatureImageBanner = (props: Props) => {
    let banner = <></>;
    if(props.features){
        banner = <Section className={props.sectionClassName ? `${styles.banner_title} ${styles.line_break} ${props.sectionClassName}` : `app-section ${styles.banner_title} ${styles.line_break}`} title={props.title} hasPadding={true} dataBg={props.isGreyBackground ? "shade-2":''} id={props.elementID ? props.elementID : ''}>
            <div className={`app-section__container container`}>
                {props.mainSubtitle && <p className={`${styles.main_subltitle}`}>{props.mainSubtitle}</p>}
                <div className={`row ${styles.feature_list} ${props.className? props.className: ''}` }>
                    {
                        props.features.map((feature, index)=>{
                            return (<FeatureImageItem index={index} scrollToTop={feature.scrollToTop? feature.scrollToTop : false} featureTitle={feature.featureTitle} featureImage={getImage(feature.featureImage)} featureText={feature.featureText} withFeatureTitle={feature.featureTitle !== undefined} key={`key-${feature.featureText}`} length={props.features.length} isRoundShape={props.isRoundShape} imageSizeClass={props.imageSizeClass}/>)
                        })
                    }
                </div>
            </div>
        </Section>
    }
    return banner;
}

export default FeatureImageBanner ;
